export default __webpack_public_path__ + "static/media/icon-transmettre.0a2d3366.svg";